var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container "},[_c('v-sheet',{staticClass:"cardback",class:_vm.card.category,attrs:{"elevation":"1"}}),_c('Card',{attrs:{"card-draft":_vm.card}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }